import React from 'react';
import { IconProps } from '.';

const SvgScreenZoomOut = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15.5 3.75h-.75v1.5h2.94l-3.72 3.72-.53.53 1.06 1.06.53-.53 3.72-3.72v2.94h1.5v-5.5H15.5Zm-1 9.69.53.53 3.72 3.72v-2.94h1.5v5.5H14.75v-1.5H17.689l-3.72-3.72-.53-.53 1.06-1.06Zm-3.94 1.06-.53.53-3.72 3.72h2.94v1.5h-5.5v-5.5h1.5v2.94l3.72-3.72.53-.53 1.06 1.06ZM3.75 3.75h5.5v1.5H6.31l3.72 3.72.53.53-1.06 1.06-.53-.53-3.72-3.72v2.94h-1.5v-5.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgScreenZoomOut;
